import { render, staticRenderFns } from "./siderVideoActions.vue?vue&type=template&id=7cca40f4&scoped=true&"
import script from "./siderVideoActions.vue?vue&type=script&lang=js&"
export * from "./siderVideoActions.vue?vue&type=script&lang=js&"
import style0 from "./siderVideoActions.vue?vue&type=style&index=0&id=7cca40f4&lang=scss&scoped=true&"
import style1 from "./siderVideoActions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cca40f4",
  null
  
)

export default component.exports